// Snap Pixel event helpers — the base pixel is loaded in public/index.html.
// Docs: https://businesshelp.snapchat.com/s/article/pixel-website-install

// Some shared UI components attach onClick on both a wrapper and its inner
// element, so one user click can invoke the handler twice — dedupe within 500ms.
// Tracked per event key (not a single last-event slot): one click now fires two
// interleaved events (CUSTOM_EVENT_* then SIGN_UP), so a single slot would let
// the duplicated second invocation through.
const lastEventAt = {};

// مصدر الزيارة (utm_source) يُحفظ عند أول دخول، لأن التنقل داخل الموقع يُسقط رابط الإعلان.
// رسالة الواتساب الجاهزة تكشف المنصة لفريق صولا فيعدّ النتائج الحقيقية لكل منصة.
const AD_SOURCE = (() => {
    if (typeof window === "undefined") return "";
    const m = /utm_source=([^&]+)/i.exec(window.location.search);
    try {
        if (m) sessionStorage.setItem("ad_source", m[1].toLowerCase());
        return sessionStorage.getItem("ad_source") || "";
    } catch (e) {
        return m ? m[1].toLowerCase() : "";
    }
})();

export const waMessage = () => {
    if (AD_SOURCE.startsWith("snap")) return "مرحباً صولا، شفت إعلانكم في سناب";
    if (AD_SOURCE.startsWith("tiktok")) return "مرحباً صولا، شفت إعلانكم في تيك توك";
    if (AD_SOURCE.startsWith("google")) return "مرحباً صولا، شفت إعلانكم في قوقل";
    return "Hello, this is Soola";
};

export const trackSnapEvent = (eventName, params = {}) => {
    if (typeof window === "undefined" || typeof window.snaptr !== "function") return;
    const key = eventName + JSON.stringify(params);
    const now = Date.now();
    if (lastEventAt[key] && now - lastEventAt[key] < 500) return;
    lastEventAt[key] = now;
    window.snaptr("track", eventName, params);
};

// TikTok pixel (DB40833C77U04C8M7RQG, base code in public/index.html) — same contact
// actions mirrored as TikTok standard events so TikTok campaigns can measure/optimize too.
export const trackTikTok = (eventName, params = {}) => {
    if (typeof window === "undefined" || !window.ttq || typeof window.ttq.track !== "function") return;
    const key = "tt:" + eventName + JSON.stringify(params);
    const now = Date.now();
    if (lastEventAt[key] && now - lastEventAt[key] < 500) return;
    lastEventAt[key] = now;
    window.ttq.track(eventName, params);
};

// Google Ads (AW-17658363686, base tag in public/index.html) — conversions for the Search campaign.
// «Website WhatsApp Click» / «Website Call Click» conversion actions (created 17/10/2026).
const GADS_WHATSAPP = "AW-17658363686/Yv_jCIjwlaAdEKb-lORB";
const GADS_CALL = "AW-17658363686/jRO8CIvwlaAdEKb-lORB";
const trackGoogleConversion = (sendTo) => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    const key = "gads:" + sendTo;
    const now = Date.now();
    if (lastEventAt[key] && now - lastEventAt[key] < 500) return;
    lastEventAt[key] = now;
    window.gtag("event", "conversion", { send_to: sendTo });
};

// Lead: successful contact-form submission.
// user_email / user_phone_number improve match quality (hashed by the pixel before sending).
export const trackSnapLead = ({ email, phone } = {}) => {
    const params = { sign_up_method: "contact_form" };
    if (email) params.user_email = email;
    if (phone) params.user_phone_number = phone;
    trackSnapEvent("SIGN_UP", params);
    trackTikTok("SubmitForm", { content_name: "contact_form" });
};

// CUSTOM_EVENT_1 = WhatsApp click, CUSTOM_EVENT_2 = phone-call click.
// Keep these numbers stable: they break contacts down by button and section.
// Each real contact action ALSO fires SIGN_UP — the standard event Snap ad
// squads can optimize on (PIXEL_SIGNUP goal), so the algorithm learns from
// every WhatsApp/call/form contact, not only form submissions.
export const trackSnapWhatsAppClick = (source) => {
    trackSnapEvent("CUSTOM_EVENT_1", { description: `whatsapp_click:${source}` });
    trackSnapEvent("SIGN_UP", { sign_up_method: `whatsapp:${source}` });
    trackTikTok("Contact", { content_name: `whatsapp:${source}` });
    trackGoogleConversion(GADS_WHATSAPP);
};

export const trackSnapCallClick = (source) => {
    trackSnapEvent("CUSTOM_EVENT_2", { description: `call_click:${source}` });
    trackSnapEvent("SIGN_UP", { sign_up_method: `call:${source}` });
    trackTikTok("Contact", { content_name: `call:${source}` });
    trackGoogleConversion(GADS_CALL);
};
